// Preserve signed product previews, selected variants, guide views, and anchors.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.be-language-switch')) return;
  let returnTo = form.querySelector('input[name="return_to"]');
  if (!returnTo) {
    returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    form.append(returnTo);
  }
  returnTo.value = window.location.pathname + window.location.search + window.location.hash;
});
